import React from "react";

function EmptyState() {
  return (
    <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed rounded p-6">
      <i className="ki-duotone ki-information fs-2tx text-warning me-4">
        <span className="path1" />
        <span className="path2" />
        <span className="path3" />
      </i>
      <div className="d-flex flex-stack flex-grow-1">
        <div className="fw-semibold">
          <h4 className="text-gray-900 fw-bold">¡Sin información!</h4>
          <div className="fs-6 text-gray-700">No se encontraron datos para mostrar. Por favor, verifica los filtros si es necesario.</div>
        </div>
      </div>
    </div>
  );
}

export default EmptyState;
